export function getInitials(fullName: string): string {
  if (typeof fullName !== 'string') {
    return '';
  }

  let initials = '';

  const name: Array<string> =
    fullName
      .trim()
      // Take care of hyphenated last names, like maiden names
      .replace(/\s*-\s*/g, '')
      // Remove anything that is not letter (or space) in any language
      .replace(/[^\p{L} ]/gu, '')
      // Split name into words
      .split(' ') || [];

  // Capture the first initial, if it exists
  if (name.length) {
    initials += name[0].charAt(0);
  }

  // Capture the last initial, if it exists
  if (name.length > 1) {
    initials += name[name.length - 1].charAt(0);
  }

  return initials;
}
